import sendTrackingEvent from 'mParticle/sendTrackingEvent'

/**
 * Tracking helpers for the new site footer and the collections directory
 * rendered above it.
 *
 * The event names below must exist in 'analytics-event-schema' for the web
 * platform, otherwise sendTrackingEvent drops them without reaching mParticle.
 */

const getPage = () => window?.location?.href || ''

/** Which part of the footer a tapped link belongs to. */
export type FooterLinkType = 'section_header' | 'section_link' | 'legal'

type FooterNavigationArgs = {
  linkType: FooterLinkType
  sectionName: string
  url: string
  urlName: string
}

export const footerNavigationTrackEvent = ({
  linkType,
  sectionName,
  url,
  urlName,
}: FooterNavigationArgs) => {
  sendTrackingEvent('FOOTER_NAVIGATION_LINK_TAP', {
    link_type: linkType,
    page: getPage(),
    section_name: sectionName,
    url,
    url_name: urlName,
  })
}

type DirectoryLinkArgs = {
  groupName: string
  sectionName: string
  url: string
  urlName: string
}

export const collectionsDirectoryLinkTrackEvent = ({
  groupName,
  sectionName,
  url,
  urlName,
}: DirectoryLinkArgs) => {
  sendTrackingEvent('COLLECTIONS_DIRECTORY_LINK_TAP', {
    group_name: groupName,
    page: getPage(),
    section_name: sectionName,
    url,
    url_name: urlName,
  })
}

type DirectorySectionArgs = {
  previousSectionName: string
  sectionName: string
}

export const collectionsDirectorySectionTrackEvent = ({
  previousSectionName,
  sectionName,
}: DirectorySectionArgs) => {
  sendTrackingEvent('COLLECTIONS_DIRECTORY_SECTION_TAP', {
    page: getPage(),
    previous_section_name: previousSectionName,
    section_name: sectionName,
  })
}

type DirectoryGroupArgs = {
  groupName: string
  previousGroupName: string
  sectionName: string
}

export const collectionsDirectoryGroupTrackEvent = ({
  groupName,
  previousGroupName,
  sectionName,
}: DirectoryGroupArgs) => {
  sendTrackingEvent('COLLECTIONS_DIRECTORY_GROUP_TAP', {
    group_name: groupName,
    page: getPage(),
    previous_group_name: previousGroupName,
    section_name: sectionName,
  })
}

type DirectoryExpandArgs = {
  groupName: string
  isExpanded: boolean
  sectionName: string
}

export const collectionsDirectoryExpandTrackEvent = ({
  groupName,
  isExpanded,
  sectionName,
}: DirectoryExpandArgs) => {
  sendTrackingEvent('COLLECTIONS_DIRECTORY_EXPAND_TAP', {
    group_name: groupName,
    is_expanded: isExpanded,
    page: getPage(),
    section_name: sectionName,
  })
}
